import { inject, Injectable } from "@angular/core";
import { ApiService } from "@app/api/api.service";
import { PARTNER_MODEL, ResPartner } from "@app/models";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { AuthApiActions } from "../actions";
import { PartnerApiActions } from "./actions";

@Injectable()
export class PartnerEffects {
  private apiService = inject(ApiService);
  private actions$ = inject(Actions);

  constructor() {}

  loadData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthApiActions.load),
      map(() => PartnerApiActions.searchPartners())
    )
  );

  searchPartners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerApiActions.searchPartners),
      switchMap(() =>
        this.apiService.search(PARTNER_MODEL).pipe(
          map((apiData) =>
            PartnerApiActions.searchPartnersSuccess({
              partners: apiData.map((item) => new ResPartner(item)),
            })
          ),
          catchError((error) =>
            of(PartnerApiActions.searchPartnersFailure({ error }))
          )
        )
      )
    )
  );
}
